/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export default function Verified({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      css={{
        ...css`
          color: #00cdb8;
        `,
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.49907C4 6.46028 6.46165 3.99828 9.5 3.99828C12.5368 3.99828 15 6.46028 15 9.49907C15 12.5363 12.5368 14.9983 9.5 14.9983C6.46165 14.9983 4 12.5363 4 9.49907Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18298 12L6.75 9.51432L7.33727 8.81891L9.12657 10.6474L12.1078 7L12.75 7.63495L9.18298 12Z"
        fill="#FEFEFE"
      />
    </svg>
  );
}

Verified.propTypes = {
  css: PropTypes.instanceOf(css),
};
